import React from 'react';
import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';

import * as constants from '../../../utils/constants';
import * as toastService from '../../../services/toastService';

class CustomUTMInspectionFormNewItem extends Form {
	state = {
		data: { sectionTitle: '', startColumn: '', endColumn: '', items: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		sectionTitle: Joi.string().required().label('Section Title'),
		startColumn: Joi.string().required().label('Start Column'),
		endColumn: Joi.string().required().label('End Column'),
		items: Joi.array().min(0).required().label('UTM Inspection Items'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);
		toastService.success('Item Added!')

		this.setState({ data: { sectionTitle: '', startColumn: '', endColumn: '', items: [] } });
	};

	onChangeSectionTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
		const value = event.target.value;
		if (['tml', 'cml'].includes(value.toLowerCase().trim())) {
			this.setState({ 
				data: { ...this.state.data, [event.target.name]: value }, 
				errors: { ...this.state.errors, [event.target.name]: 'Please provide more details' }
			});
		} else {
			this.handleChange(event);
		}
	}

	getStartAlphabetOptions = () => {
		return constants.ALPHABET.map((letter) => ({ id: letter, name: letter }));
	}

	getEndAlphabetOptions = () => {
		const allAlphabetOptions = this.getStartAlphabetOptions();

		const index = allAlphabetOptions.findIndex((letter) => letter.id === this.state.data.startColumn);
		if (index !== -1) return allAlphabetOptions.slice(index);

		return allAlphabetOptions;
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="container">
					{this.renderInput({
						type: 'text',
						name:'sectionTitle', 
						label:'Section Title / Name of UTM',
						placeholder:'Enter Section Title / Name of UTM e.g. TML e.g. TML',
						onChange: this.onChangeSectionTitle,
					})} 

					<div className="row">
						<div className="col">
							{this.renderSelect({
								name:'startColumn', 
								options: this.getStartAlphabetOptions(),
								label:'Start Column',
								placeholder:'Select Start Column',
							})} 
						</div>

						<div className="col">
							{this.renderSelect({
								name:'endColumn', 
								options: this.getEndAlphabetOptions(),
								label:'End Column',
								placeholder:'Select End Column',
							})} 
						</div>
					</div>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end align-items-center">
					{this.renderButton('Add New Section')}
				</div>
			</form>
		);
	}
}

export default CustomUTMInspectionFormNewItem;
